import React from 'react'
import { Tooltip } from 'antd'
import { commaingNumber } from '../../utils'
import { SALES_ROLE as role } from '../../constants/overview'


const leaderBoardIndividualSchema = ({data, type}) => {
  let teamName = data.team_name ? data.team_name : <Tooltip placement='bottom' title={`${data.name} has not yet participated in the Stepathon`}>-</Tooltip>
  return (
    <tr className='text-gray-600' key={data.id} >
      <td className={`pl-3 pr-4 py-4 font-semibold ${role === 'sales' && 'filter blur-sm select-none' }`} style={{width: '20%'}}>{data.name}</td>
      <td className='pl-8 pr-4 py-4 ' style={{width: '20%'}}> {data.employee_id} </td>
       <td className='pr-4 py-4'  style={{width: '20%', paddingLeft: '76px'}}>{commaingNumber(data.overall_step_count)}</td>
       <td className={`pl-3 pr-4 py-4  ${role === 'sales' && 'filter blur-sm select-none' }`} style={{width: '20%'}}><span>{data.email}</span></td>
       { type !== 'individual' && 
          <td className='pl-3 pr-4 py-4 font-semibold cursor-pointer' style={{width: '20%'}}>{teamName}</td>
       }
    </tr>
  )
}

export default leaderBoardIndividualSchema